export let CategoryKey;

(function (CategoryKey) {
  CategoryKey["Heroes"] = "heroes";
  CategoryKey["Pets"] = "pets";
  CategoryKey["ThetaBox"] = "thetabox";
  CategoryKey["GiftBox"] = "giftbox";
  CategoryKey["Cosmetic"] = "cosmetic";
  CategoryKey["Others"] = "others";
})(CategoryKey || (CategoryKey = {}));